export const SOURCE_FIELDS = [
  ['mededeling', 'Mededeling'], ['factuurnummer', 'Factuurnummer'], ['datum', 'Factuurdatum'], ['vervaldag', 'Vervaldatum'],
  ['totaal', 'Incl. BTW'], ['excl', 'Excl. BTW'], ['btw_bedrag', 'BTW-bedrag'], ['iban', 'IBAN'],
  ['leverancier', 'Leverancier'], ['leverancier_btw', 'BTW-nummer'], ['leverancier_email', 'E-mail'], ['leverancier_tel', 'Telefoon'],
  ['klantnummer', 'Klantnummer'], ['po_referentie', 'PO-referentie'], ['bestelnummer', 'Bestelnummer'], ['leveringsnummer', 'Leveringsnummer'],
  ['onze_referentie', 'Referentie'], ['betreft', 'Betreft'], ['btw_pct', 'BTW %'], ['aftrekbaarheid', 'Aftrekbaar %'],
  ['grootboekrekening', 'Grootboekrekening'], ['incoterm', 'Incoterm'], ['land_bestemming', 'Land bestemming'], ['betaalwijze', 'Betaalwijze'], ['btw_regime', 'BTW-regime'],
];
export const SOURCE_TEST_IDS = {
  'f-mededeling':'mededeling', 'f-factuurnummer':'factuurnummer', 'f-datum':'datum', 'f-vervaldag':'vervaldag', 'f-vervaldag-bet':'vervaldag',
  'f-totaal':'totaal','f-excl':'excl','f-leverancier-iban':'iban','f-leverancier':'leverancier', 'f-leverancier-btw':'leverancier_btw',
  'f-leverancier-email':'leverancier_email','f-leverancier-tel':'leverancier_tel','f-klantnummer':'klantnummer','f-po-referentie':'po_referentie',
  'f-bestelnummer':'bestelnummer','f-leveringsnummer':'leveringsnummer','f-btw-pct':'btw_pct','f-aftrekbaarheid':'aftrekbaarheid',
  'f-grootboek':'grootboekrekening','f-incoterm':'incoterm','f-land-bestemming':'land_bestemming','f-betaalwijze':'betaalwijze','f-btw-regime':'btw_regime',
};

export function suggestSourceValue(field, text) {
  let value = text.trim();
  const labels = SOURCE_FIELDS.find(([key]) => key === field)?.[1];
  if (labels && value.toLowerCase().startsWith(`${labels.toLowerCase()}:`)) value = value.slice(labels.length + 1).trim();
  if (field === 'iban') value = value.replace(/\s/g, '').toUpperCase();
  if (['totaal','excl','btw_bedrag','btw_pct','aftrekbaarheid'].includes(field)) value = value.replace(/EUR|€|%/gi, '').trim();
  if (['datum','vervaldag'].includes(field)) {
    const m = value.match(/^(\d{1,2})[/.\-](\d{1,2})[/.\-](\d{4})$/);
    if (m) value = `${m[3]}-${m[2].padStart(2,'0')}-${m[1].padStart(2,'0')}`;
  }
  return value;
}

export function sourceWarning(field, value) {
  if (!value.trim()) return 'De waarde is leeg.';
  if (['totaal','excl','btw_bedrag','btw_pct','aftrekbaarheid'].includes(field) && !/^-?[\d.,\s]+$/.test(value)) return 'Selecteer één bedrag of pas het voorstel aan.';
  if (field === 'mededeling') {
    const compact = value.replace(/[\s+/]/g, '');
    if (value.startsWith('+++') || /^\d{3}\/\d{4}\/\d{5}$/.test(value) || /^\d{12}$/.test(compact)) {
      if (!/^\d{12}$/.test(compact) || (Number(compact.slice(0,10)) % 97 || 97) !== Number(compact.slice(10))) return 'De controlecijfers van deze gestructureerde mededeling kloppen niet.';
    }
  }
  return '';
}